// extracted by mini-css-extract-plugin
module.exports = {"jds-CellCTA":"CellCTA_jds-CellCTA__60Ck_"};